import { z } from 'zod';

/**
 * One confirmed assignment: the company name as it appeared in the uploaded
 * sheet, and the supplier company the admin assigned it to. Rows the admin left
 * without a company are dropped before the request, so `matchedCompanyId` is
 * required.
 *
 * Keys are camelCase. `vestigasApi` snake_cases the body and camelCases the
 * response, so these names map to OpenAPI `input_company_name` /
 * `matched_company_id` and the apply-result fields.
 */
const zodHubspotImportApplyAssignmentSchema = z.object({
  customerNumber: z.string().nullable(),
  inputCompanyName: z.string(),
  matchedCompanyId: z.uuid(),
});

export const zodHubspotImportApplyPayloadSchema = z.array(
  zodHubspotImportApplyAssignmentSchema,
);

/**
 * `HubspotImportApplyResult` in the OpenAPI spec. There is no `ratio` field
 * on this endpoint's matched items — that belongs to the preview/match
 * response's score, not the apply result — and `notFound` (rows the backend
 * could not resolve back to a company) is required but was previously
 * missing entirely.
 */
export const zodHubspotImportApplyResponseSchema = z.object({
  companyId: z.uuid(),
  matched: z.array(
    z.object({
      alreadyRelevant: z.boolean(),
      companyId: z.uuid(),
      companyName: z.string(),
      dataExchangeId: z.uuid(),
      inputName: z.string(),
    }),
  ),
  notFound: z.array(z.string()),
});

export const zodHubspotImportApplyEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('company'),
  z.uuid(),
  z.literal('hubspot_import_apply'),
]);
